// src/composables/getServiceAd.js
import { ref } from 'vue';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const useGetServiceAd = (id) => {
  const serviceAd = ref(null);
  const error = ref(null);
  const loading = ref(false);

  const fetchServiceAd = async () => {
    loading.value = true;
    try {
      const docRef = doc(db, 'services', id);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const adData = docSnap.data();
        
        // İlanın yayınlanmış ve aktif olduğunu kontrol et
        if (adData.isActive === true && adData.isPublished === true) {
          serviceAd.value = { id: docSnap.id, ...adData };
        } else {
          // İlan aktif veya yayınlanmış değilse hata fırlat
          throw new Error('Bu servis ilanı aktif değil veya yayınlanmamış.');
        }
      } else {
        throw new Error('Belirtilen servis ilanı bulunamadı.');
      }
    } catch (err) {
      console.error('Error fetching service ad:', err);
      error.value = err.message;
      serviceAd.value = null; // Hata durumunda null olarak ayarla
    } finally {
      loading.value = false;
    }
  };

  return { serviceAd, error, loading, fetchServiceAd };
};